import { CardDomain } from "@/Cards";

interface LuckyCard {
  card: CardDomain | null;
  luckyCardStatus: LuckyCardStatus|null;
}

enum LuckyCardStatus {
  Selected = "selected",
  Lucky = "lucky",
  Guessed = "guessed",
}

const mapLuckyCardDtoToDomain = (
  dto: CardDomain,
  luckyCardStatus?: LuckyCardStatus | null,
): LuckyCard => {
  return {
    card: dto,
    luckyCardStatus: luckyCardStatus ?? null,
  };
};

export type { LuckyCard };
export { mapLuckyCardDtoToDomain, LuckyCardStatus };
